// export default 'http://avior.velocitywebworks.com:28220';
// export default 'http://localhost:8000';
export default 'https://bosombestiesbackend.velocitybeta.com';
